import request from "@/utils/request";
// 设备信息
// 运维人员
export function equipmentManager(params) {
  const { sbid } = params;
  return request({
    url: `/system/manager/equipmentManager/${sbid}`,
    method: "get",
  });
}
// 新增设备
export function addDevice(params) {
  return request({
    url: "/system/sbinfo/addSbInfo",
    method: "post",
    data: params,
  });
}
// 修改设备
export function upDateDevice(params) {
  return request({
    url: "/system/sbinfo/updateSbInfoById",
    method: "post",
    data: params,
  });
}
// 查询设备
export function queryDevice(id) {
  return request({
    url: `/system/sbinfo/${id}`,
    method: "get",
  });
}
// 批量修改设备状态
export function batchSbState(params) {
  return request({
    url: `/system/sbinfo/batchSbState`,
    method: "post",
    data: params,
  });
}
// 设备信息列表
export function getDeviceList(params) {
  return request({
    url: "/system/sbinfo/deviceList",
    method: "post",
    data: params,
  });
}
// 取消激活
export function updateActive(params) {
  return request({
    url: `system/sbinfo/cancelsActiveById`,
    method: "post",
    data: params
  });
}
// 删除未激活设备
export function deleteSbInfo(params) {
  const { id } = params;
  return request({
    url: `system/sbinfo/deleteSbInfoById/${id}`,
    method: "delete",
  });
}
// 设备外设
// 设备信息列表
export function sbCshwbList(params) {
  return request({
    url: "/system/ws/sbwsList",
    method: "post",
    data: params,
  });
}
// 初始化外设备
export function initializingWs(params) {
  return request({
    url: "/system/ws/initializingWs",
    method: "post",
    data: params,
  });
}
// 查询外部设备
export function getSbCshwbById(params) {
  const { id } = params;
  return request({
    url: `/system/ws/${id}`,
    method: "get",
  });
}
// 获取C端外部设备信息并更新
export function clientUpdate(params) {
  return request({
    url: `/system/ws/clientUpdate`,
    method: "post",
    data: params
  });
}
// 修改外部设备
export function updateSbWs(params) {
  return request({
    url: `/system/ws/updateSbWs`,
    method: "post",
    data: params,
  });
}
// 新增外部设备
export function addWs(params) {
  return request({
    url: `/system/ws/addWs`,
    method: "post",
    data: params,
  });
}
// 对外部设备下发命令
export function setPrinter(params) {
  return request({
    url: `/system/ws/setPrinter`,
    method: "post",
    data: params,
  });
}
// 初始化外部设备
// 设备信息列表
export function getOutDeviceList(params) {
  return request({
    url: "/system/cshwb/sbCshwbList",
    method: "post",
    data: params,
  });
}
// 部署管理
// 获取部署管理列表
export function sbDeployGl(params) {
  const { id } = params;
  return request({
    url: `/system/bsinfo/sbDeployGl/${id}`,
    method: "get",
  });
}
export function edit(params) {
  return request({
    url: `/system/bsinfo/edit`,
    method: "post",
    data: params,
  });
}

